import axiosInstance from "../axiosConfig";
import { ArchivedCourse, CourseTransferOptions, StorageSummary } from "./storageService.types";

export const fetchStorageSummary = async (): Promise<StorageSummary> => {
  const response = await axiosInstance.get<StorageSummary>("storage/summary/");
  return response.data;
};

export const requestArchiveCode = async (): Promise<{ detail: string; retry_after: number }> => {
  const response = await axiosInstance.post("storage/archive/code/");
  return response.data;
};

export const verifyArchiveCode = async (code: string): Promise<{ detail: string; expires_in: number }> => {
  const response = await axiosInstance.post("storage/archive/verify/", { code });
  return response.data;
};

export const requestExtraStorage = async (requestedBytes: number) => {
  const response = await axiosInstance.post("storage/extra-request/", {
    requested_bytes: requestedBytes,
  });
  return response.data;
};

export const fetchArchivedCourses = async (): Promise<ArchivedCourse[]> => {
  const response = await axiosInstance.get<ArchivedCourse[]>("storage/archive/courses/");
  return response.data;
};

export const restoreArchivedCourse = async (courseId: number): Promise<void> => {
  await axiosInstance.post("storage/archive/courses/", { course_id: courseId });
};

export const fetchCourseTransferOptions = async (): Promise<CourseTransferOptions> => {
  const response = await axiosInstance.get<CourseTransferOptions>("storage/transfers/");
  return response.data;
};

export const createCourseTransfer = async (courseId: number, recipientEmail: string): Promise<{ transfer_id: number }> => {
  const response = await axiosInstance.post("storage/transfers/", {
    course_id: courseId,
    recipient_email: recipientEmail,
  });
  return response.data;
};

export const confirmCourseTransfer = async (transferId: number, password: string, code: string): Promise<void> => {
  await axiosInstance.post("storage/transfers/confirm/", {
    transfer_id: transferId,
    password,
    code,
  });
};

export const confirmIncomingCourseTransfer = async (transferId: number, code: string): Promise<void> => {
  await axiosInstance.post("storage/transfers/recipient-confirm/", { transfer_id: transferId, code });
};
